import { axios, API } from './config';

export const aiAssistAPI = {
  draftEmail: async ({ contract_id, email_type, custom_instructions }) => {
    const res = await axios.post(`${API}/ai/draft-email`, { contract_id, email_type, custom_instructions });
    return res.data;
  },
  beoSummary: async ({ contract_id }) => {
    const res = await axios.post(`${API}/ai/beo-summary`, { contract_id });
    return res.data;
  },
};
